import { useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { Button, Dialog } from '..';
import { Label, LabelProps } from '../Label';
import './FieldLabel.scss';

type FieldLabelProps = {
  additionalInformationDialogContent?: string | JSX.Element;
  additionalInformationDialogTitle?: string;
  additionalInformationDialogVisible?: boolean;
} & LabelProps;

const FieldLabel: React.FC<React.PropsWithChildren<FieldLabelProps>> = ({
  children,
  className,
  emph,
  htmlFor,
  style,
  visible = true,
  noRecase = false,
  additionalInformationDialogContent,
  additionalInformationDialogTitle = 'Description',
  additionalInformationDialogVisible = true,
}) => {
  const [visibleDialog, setVisibleDialog] = useState(false);
  const closeDialogs = () => {
    setVisibleDialog(false);
  };
  const buttons = [
    <Button key="1" onClick={closeDialogs}>
      Close
    </Button>,
  ];

  return !visible ? null : typeof additionalInformationDialogContent === 'undefined' ||
    additionalInformationDialogVisible !== true ? (
    <Label className={className} emph={emph} htmlFor={htmlFor} style={style} visible={visible} noRecase={noRecase}>
      {children}
    </Label>
  ) : (
    <div className="FieldLabel">
      <div className="FieldLabel-Label">
        <Label className={className} emph={emph} htmlFor={htmlFor} style={style} visible={visible} noRecase={noRecase}>
          {children}
        </Label>
      </div>
      <div className="FieldLabel-Info">
        <div className="FieldLabel-BtnContainer">
          <Button subtle className="FieldLabel-Btn" onClick={() => setVisibleDialog(true)}>
            <FaInfoCircle size="1.2em" />
          </Button>
        </div>
        <Dialog
          buttons={buttons}
          onClose={closeDialogs}
          title={additionalInformationDialogTitle}
          visible={visibleDialog}
          width="500px"
        >
          {additionalInformationDialogContent}
        </Dialog>
      </div>
    </div>
  );
};

export { FieldLabel };
export default FieldLabel;
